import React from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { ButtonVariant } from '..';

export default function Dialog({
    title,
    children,
    height,
    show,
    buttonOKText,
    buttonOKType,
    buttonCancelText,
    buttonCancelType,
    buttonCancelVisible,
    onOK,
    onCancel
}) {

    // https://stackoverflow.com/a/55056066/2146129
    const opacity = show ? 1 : 0;

    if (!height)
        height = 'calc(100vh - 400px)';

    if (!buttonOKText)
        buttonOKText = 'OK';

    if (!buttonOKType)
        buttonOKType = ButtonVariant.OUTLINE_PRIMARY;

    if (!buttonCancelText)
        buttonCancelText = 'Cancel';

    if (!buttonCancelType)
        buttonCancelType = ButtonVariant.SECONDARY;

    if (!buttonCancelVisible)
        buttonCancelVisible = false;

    const onDialogOK = () => {
        if (onOK)
            onOK();
    };

    const onDialogCancel = () => {
        if (onCancel)
            onCancel();
    };

    return (
        <Modal
            show={show}
            backdrop='static'
            keyboard={false}
            scrollable={true}
            style={{
                opacity: opacity,
                height: height,
            }}
        >
            <Modal.Header>
                <Modal.Title id='contained-modal-title-vcenter'>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body >
                {children}
            </Modal.Body>
            <Modal.Footer>
                <Button
                    variant={buttonOKType}
                    onClick={onDialogOK}
                >
                    {buttonOKText}
                </Button>
                {(
                    buttonCancelVisible &&
                    <Button
                        variant={buttonCancelType}
                        onClick={onDialogCancel}
                    >
                        {buttonCancelText}
                    </Button>
                )}
            </Modal.Footer>
        </Modal>
    );
}